import { playbackLiveActions } from '@/actions/playbackLiveActions'

const initialState = {
  liveList: [],
  params: { page: 1, pageSize: 10, type: 2 },
  position: 0,
  liveNoMore: false
}
export default (state = initialState, { payload, type }) => {
  switch (type) {
    case playbackLiveActions.LIVE_LIST:
      return {
        ...state,
        liveList: payload
      }
    case playbackLiveActions.LIVE_PARAMS:
      return {
        ...state,
        params: payload
      }
    case playbackLiveActions.LIVE_POSITION:
      return {
        ...state,
        position: payload
      }
    case playbackLiveActions.LIVE_NOMORE:
      return {
        ...state,
        liveNoMore: payload
      }
    default:
      return state
  }
}
